import { Component, Input, OnInit } from '@angular/core';
import { TYPE_IROPS } from '@app/enums/irops.enum';

@Component({
    selector: 'subtitle-irops-view',
    templateUrl: './subtitle-irops-view.component.html',
    styleUrls: ['./subtitle-irops-view.component.scss'],
    standalone: false
})
export class SubtitleIropsViewComponent implements OnInit {
  typeIrops = TYPE_IROPS;

  @Input() subtitle = this.typeIrops.DELAYED;

  constructor() { }

  ngOnInit() {
  }

}
